<template>
    <div>
        <el-form :model="form" label-width="150px">
            <el-form-item label="用户名">
              <el-input v-model="form.userName" disabled></el-input>
            </el-form-item>
            <el-form-item label="新 密 码">
                <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
let that
export default {
    
    data(){
        return {
            form: {
                userName: '',
                password: '',
                newPassword: ''
            }
           
        }
    },
    
    methods: {
        handleConfirm() {
            
            that.api.manager.modifyPassword(that.form).then( res => {
                that.$message.success(res.data)
                that.$dialog.close('modifyPassword')
            })
        }
    },
    mounted(){
        that = this
        that.form = that.globalData.manager
        that.form.password = ''

    }
}
</script>

